import { createAction } from '@reduxjs/toolkit';

export const resetAllAction = createAction('resetAll');
